import { SectionActionTypeEnums } from '@/enums/SectionActionTypeEnums';

export interface IConfigurationAction {
    title: string;
    action: SectionActionTypeEnums;
    identifier: string;
}

export class ConfigurationAction {
    public title: string;
    public action: SectionActionTypeEnums;
    public identifier: string;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IConfigurationAction);
    constructor(obj?: any) {
        this.title = obj && obj.title || '';
        this.action = obj && obj.action != null ? obj.action : SectionActionTypeEnums.ADD;
        this.identifier = obj && obj.identifier || '';
    }
}
